import React from "react";
import { AxiosResponse } from "axios";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";

import { IServiceCategory, IPageContent } from "app/api/types";
import {
  getServiceCategories,
  addServiceCategory,
  delServiceCategory,
  editServiceCategory
} from "app/api/redux/ServiceCategories/actions";
import {
  getPageContentById,
  editPageContent,
  addPageContent,
  delPageContent
} from "app/api/redux/PageContent/actions";
import ServiceCategoriesList from "app/components/ServiceCategoriesList";
import LayoutUser from "app/components/LayoutUser";

import "./styles.scss";

interface IProps extends RouteComponentProps<{ id: string }> {
  serviceCategoriesList: IServiceCategory[];
  isLoading: boolean;
  getServiceCategories: () => Promise<AxiosResponse>;
  addServiceCategory: (data: IServiceCategory) => Promise<IServiceCategory>;
  delServiceCategory: (data: IServiceCategory["id"]) => Promise<AxiosResponse>;
  editServiceCategory: (data: IServiceCategory) => Promise<IServiceCategory>;
  getPageContentById: (id: string) => Promise<[IPageContent]>;
  addPageContent: (data: IPageContent) => Promise<AxiosResponse>;
  delPageContent: (id: IPageContent["pageId"]) => Promise<AxiosResponse>;
  editPageContent: (data: IPageContent) => Promise<AxiosResponse>;
}

class ServiceCategoriesPage extends React.Component<IProps> {
  componentDidMount() {
    this.props.getServiceCategories().catch(err => {
      console.log(err);
      this.props.history.push("/404");
    });
  }

  render() {
    return (
      <LayoutUser>
        <ServiceCategoriesList
          serviceCategoriesList={this.props.serviceCategoriesList}
          isLoading={this.props.isLoading}
          addServiceCategory={this.props.addServiceCategory}
          delServiceCategory={this.props.delServiceCategory}
          editServiceCategory={this.props.editServiceCategory}
          getServiceCategories={this.props.getServiceCategories}
          addPageContent={this.props.addPageContent}
          delPageContent={this.props.delPageContent}
          editPageContent={this.props.editPageContent}
          getPageContentById={this.props.getPageContentById}
        />
      </LayoutUser>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    serviceCategoriesList: state.serviceCategories.serviceCategoriesList,
    isLoading: state.serviceCategories.isLoading
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getServiceCategories,
    addServiceCategory,
    delServiceCategory,
    editServiceCategory,
    editPageContent,
    addPageContent,
    getPageContentById,
    delPageContent
  })(ServiceCategoriesPage)
);
